import { Factory } from 'rosie';
import { ClaimablePoints } from 'rpc/model/squareup/card/balance/loyalty_api/model/claimable-points';

export const ClaimablePointsFactory = new Factory<ClaimablePoints>()
  .attr('merchantId', 'merchant-id')
  .attr('points', 42)
  .attr('reason', ClaimablePoints.Reason.MISSED_TRANSACTION)
  .attr('requiresTosConsent', true);
